module.exports = __webpack_public_path__ + "img/team-julia@2x.fa1dd6ac.jpg";